import { ColDef } from 'ag-grid-community';

/**
 * Wallet type filter options for the wallet ledger report
 */
export const WALLET_LEDGER_REPORT_WALLET_TYPE_OPTIONS = [
  { label: 'Merchant', value: 'MERCHANT' },
  { label: 'Customer', value: 'CUSTOMER' }
];

/**
 * Debit/Credit filter options for the wallet ledger report
 */
export const WALLET_LEDGER_REPORT_DEBIT_CREDIT_OPTIONS = [
  { label: 'Credit', value: 'CREDIT' },
  { label: 'Debit', value: 'DEBIT' }
];

/**
 * Transaction status filter options for the wallet ledger report
 */
export const WALLET_LEDGER_REPORT_STATUS_OPTIONS = [
  { label: 'Success', value: 'SUCCESS' },
  { label: 'Failed', value: 'FAILED' },
  { label: 'Pending', value: 'PENDING' },
  { label: 'Request Initiated', value: 'REQUEST_INITIATED' },
  { label: 'Refund', value: 'REFUNDED' },
  { label: 'Reversed', value: 'REVERSED' }
];

/**
 * Column definitions for the wallet ledger report grid
 */
export const WALLET_LEDGER_REPORT_COLUMN_DEFS: ColDef[] = [
  {
    field: 'date', sortable: false, lockVisible: true, headerName: 'Date',
    valueFormatter: (params) => params.value ? new Date(params.value).toLocaleString() : 'N/A'
  },
  { field: 'walletType', sortable: false, lockVisible: true, headerName: 'Wallet Type', valueGetter: (params) => params.data?.walletType || 'N/A' },
  { field: 'mobileNumber', sortable: false, lockVisible: true, headerName: 'Mobile Number', valueGetter: (params) => params.data?.mobileNumber || 'N/A' },
  { field: 'trxType', sortable: false, lockVisible: true, headerName: 'Transaction Type', valueGetter: (params) => params.data?.trxType || 'N/A' },
  { field: 'trxStatus', sortable: false, lockVisible: true, headerName: 'Status', valueGetter: (params) => params.data?.trxStatus || 'N/A' },
  { field: 'debitCredit', sortable: false, lockVisible: true, headerName: 'Credit / Debit', valueGetter: (params) => params.data?.debitCredit || 'N/A' },
  {
    field: 'amount', sortable: false, lockVisible: true, headerName: 'Amount',
    valueFormatter: (params) => params.value != null ? Number(params.value).toFixed(2) : 'N/A'
  },
  {
    field: 'fees', sortable: false, lockVisible: true, headerName: 'Fees',
    valueFormatter: (params) => params.value != null ? Number(params.value).toFixed(2) : 'N/A'
  },
  {
    field: 'netAmount', sortable: false, lockVisible: true, headerName: 'Net Amount',
    valueFormatter: (params) => params.value != null ? Number(params.value).toFixed(2) : 'N/A'
  },
  {
    field: 'balance', sortable: false, lockVisible: true, headerName: 'Balance',
    valueFormatter: (params) => params.value != null ? Number(params.value).toFixed(2) : 'N/A'
  },
  { field: 'statusUpdatedBy', sortable: false, lockVisible: true, headerName: 'Status Updated By', valueGetter: (params) => params.data?.statusUpdatedBy || 'N/A' },
  {
    field: 'statusUpdateTime', sortable: false, lockVisible: true, headerName: 'Status Update Time',
    valueFormatter: (params) => params.value ? new Date(params.value).toLocaleString() : 'N/A'
  }
];
